<style src="./Simple.scss" lang="scss"></style>

<script>
	import Icon from '@/components/Icon/Icon';

	/**
	 * Simple component consisting of image and text.
	 * @vue-prop {string} [img] URL of image
	 * @vue-prop {string} text The text of the component
	 * @vue-prop {Object} link An object representing the link
	 * @vue-prop {string} [icon] A string representing the icon to use instead of image
	 * @vue-prop {('vertical' | 'horizontal' | 'vertical-reverse' | 'horizontal-reverse')} [orientation] The direction of the component
	 * @vue-prop {('rectangle' | 'circle')} shape The shape of the image
	 * @vue-prop {('' | 'grey')} [backgroundColor] Color of the background of whole component
	 * @vue-prop {('' | 'blue')} [imageBackgroundColor] Color of the background of the image
	 * @fires Simple#click
	 */
	export default {
		props: {
			img: String,
			text: String,
			link: {
				href: String,
				target: String
			},
			icon: String,
			orientation: {
				type: String,
				default: 'vertical',
				validator: function (value) {
					return ['vertical', 'horizontal', 'vertical-reverse', 'horizontal-reverse'].indexOf(value) !== -1;
				}
			},
			shape: {
				type: String,
				validator: function (value) {
					return ['rectangle', 'circle'].indexOf(value) !== -1;
				}
			},
			backgroundColor: String,
			imageBackgroundColor: String
		},
		components: {
			'hp-icon': Icon
		}
	};
</script>

<template>
	<component :is="link ? 'a' : 'div'" :href="link && link.href ? link.href : false" :target="link && link.target ? link.target : false" @click="$emit('click')">
		<figure data-component="simple" :data-orientation="orientation" :data-background-color="backgroundColor">
			<div v-if="icon" :data-background-color="imageBackgroundColor">
				<hp-icon :type="icon"></hp-icon>
			</div>
			<img v-else :src="img" :alt="text" :data-shape="shape" />
			<figcaption>{{ text }}</figcaption>
		</figure>
	</component>
</template>
